import React from 'react';
import { Box, Typography } from '@mui/material';
import { DocumentsTableRow } from 'modules/customers/types';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

interface Props {
  row: DocumentsTableRow;
}

export const FilenameCell = ({ row }: Props) => {
  return (
    <Box display="flex" alignItems="center">
      <InsertDriveFileIcon color="primary" />
      <Typography ml={1} variant="body2">
        {row.docName}
      </Typography>
    </Box>
  );
};
